import { render } from "./M15-BestSellerCard.vue?vue&type=template&id=52867b9e"
import script from "./M15-BestSellerCard.vue?vue&type=script&lang=js"
export * from "./M15-BestSellerCard.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__